import React, { useState } from 'react';
import { IPasswordField } from './interfaces';
import { TextField } from '../TextField';
import { IconButton, InputAdornment } from '@mui/material';
import { StrengthMeter } from './components/StrengthMeter';
import { calculateStrength } from './helper';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const PasswordField: React.FC<IPasswordField> = ({
  label,
  helperText,
  placeholder,
  required,
  error,
  value,
  rules,
  strengthMeter = false,
  onChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const strength = calculateStrength(value || '');

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <TextField
      label={label}
      placeholder={placeholder}
      required={required}
      error={error}
      helperText={helperText}
      onChange={onChange}
      value={value}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label={
              showPassword
                ? t('forms:fields.passwordField.ariaLabels.hidePassword')
                : t('forms:fields.passwordField.ariaLabels.showPassword')
            }
            size="small"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
            onMouseUp={handleMouseUpPassword}
            edge="end"
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      type={showPassword ? 'text' : 'password'}
    >
      {strengthMeter && <StrengthMeter strength={strength} />}
    </TextField>
  );
};
